import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/errors";
import { toast } from "sonner";
import { ArrowLeft, Copy, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProposalDocument, ProposalToolbar } from "@/components/proposal/ProposalDocument";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProposalView() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/dealer/proposals/${id}/preview`).then((r) => setData(r.data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  }, [id]);
  if (!data) return <Loader2 className="mt-12 h-6 w-6 animate-spin text-terracotta" />;
  const copy = () => navigator.clipboard?.writeText(`${window.location.origin}${data.public_path}`).then(() => toast.success("Client link copied"));
  return (
    <div className="mx-auto max-w-4xl" data-testid="dealer-proposal-view">
      <Link to="/dealer/proposals" className="print:hidden mb-4 inline-flex items-center text-xs text-warmgrey hover:text-charcoal" data-testid="proposal-view-back">
        <ArrowLeft className="mr-1 h-3.5 w-3.5" /> Back to quotes
      </Link>
      <ProposalToolbar pdfUrl={`${API}/dealer/proposals/${id}/pdf`} extra={
        data.status !== "DRAFT" && (
          <Button size="sm" variant="outline" onClick={copy} data-testid="proposal-view-copy-link" className="border-limestone text-charcoal hover:bg-sand">
            <Copy className="mr-1 h-3.5 w-3.5" /> Copy link
          </Button>
        )} />
      {data.status === "DRAFT" && <p className="print:hidden mb-3 text-xs text-[#8a6435]" data-testid="proposal-view-draft-note">Draft preview — finalize to share with your client.</p>}
      <ProposalDocument data={data} logoUrl={`${API}/dealer/branding/logo?v=${encodeURIComponent(data.branding?.logo_version || "")}`} />
    </div>
  );
}
